<template>
  <my-modal
    :title="title"
    v-model:visible="visibleModel"
    :saving="loading"
    @save="handleSave"
    >
    <div v-if="loading" class="h-20 flex items-center justify-center">
      <span>Уншиж байна...</span>
    </div>
    <my-panel v-else-if="item" background="">
      <my-input label="Код" v-model="item.code" required />
      <my-input label="Нэр" v-model="item.name" required />
    </my-panel>
  </my-modal>
</template>
<script>
export default {
  props: {
    visible: { type: Boolean, default: false },
    tableName: { type: String, default: '' },
    id: { type: Number, default: null }
  },
  data () {
    return {
      saving: false,
      loading: false,
      item: null
    }
  },
  computed: {
    title () {
      return this.id ? 'Засварлах' : 'Бүртгэх'
    },
    visibleModel: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.handleRefresh()
      }
    }
  },
  methods: {
    async handleRefresh () {
      try {
        this.loading = true
        this.item = { code: '', name: '' }
        this.loading = true
        if (this.id) {
          this.item = (await this.axios.get(`lookups/one/${this.tableName}/${this.id}`)).data
        }
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    },
    async handleSave () {
      try {
        this.saving = true
        const data = (await this.axios.post('lookups', {
          tableName: this.tableName,
          name: this.item.name,
          code: this.item.code,
          id: this.id
        })).data
        this.$emit('saved', data)
        this.visibleModel = false
        this.showToast('Амжилттай хадгаллаа.')
      } catch (err) {
        this.handleError(err)
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
